
import React, {useState, useEffect, useCallback, useRef} from 'react'
import { Editor } from '@tinymce/tinymce-react';


function Test() {

  const editorRef = useRef(null);
  const log = () => {
    if (editorRef.current) {
      console.log(editorRef.current.getContent());
    }
  };

 
  useEffect(() => {
    
  }, []);


  

  return (
    <div style={{ maxWidth: "100%", height: "auto" }}>
        <div className='m-5'>
        <>
      <Editor
        apiKey='awvf0ud3r4xmskmpp7r3aooqw1f85ukerl49ay7vor4tzhmo'
        onInit={(_evt, editor) => editorRef.current = editor}
        initialValue=""
        init={{
          height: 500,
          menubar: false,
          plugins: [
            'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
            'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
            'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
          ],
          toolbar: 'undo redo | blocks | ' +
            'bold italic forecolor | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'removeformat | help',
          content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
        }}
      />
      <button onClick={log}>Log editor content</button>
    </>

        </div>
        

    </div>
  )
}

export default Test
